import { useState } from 'react';
import { Alert, Button, Card, Checkbox, Form, Input, Typography } from 'antd';

import { useAuth } from './AuthProvider';
import { getLoginErrorMessage } from './loginErrors';
import { resolveLoginRedirectPath } from './loginRedirect';

interface LoginFormValues {
  username: string;
  password: string;
  rememberMe?: boolean;
}

export function LoginErrorAlert({ message }: { message: string | null }) {
  if (!message) {
    return null;
  }

  return <Alert type="error" showIcon message={message} />;
}

export function LoginPage() {
  const { login } = useAuth();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleFinish = async (values: LoginFormValues) => {
    setErrorMessage(null);
    setSubmitting(true);

    try {
      await login({
        username: values.username.trim(),
        password: values.password,
        rememberMe: Boolean(values.rememberMe),
      });
      const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      const fallbackPath = window.location.pathname === '/login' ? '/' : currentPath;
      const redirectPath = resolveLoginRedirectPath(window.location.search, fallbackPath);
      if (redirectPath !== currentPath) {
        window.history.replaceState(null, '', redirectPath);
      }
    } catch (error) {
      setErrorMessage(getLoginErrorMessage(error));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <Card style={{ width: '100%', maxWidth: 380 }}>
        <Typography.Title level={2} style={{ marginTop: 0, textAlign: 'center' }}>
          VP Quant
        </Typography.Title>
        <Form<LoginFormValues> layout="vertical" onFinish={handleFinish} requiredMark={false}>
          <LoginErrorAlert message={errorMessage} />
          <Form.Item
            label="用户名"
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input autoComplete="username" placeholder="用户名" />
          </Form.Item>
          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password autoComplete="current-password" placeholder="密码" />
          </Form.Item>
          <Form.Item name="rememberMe" valuePropName="checked">
            <Checkbox>记住我</Checkbox>
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={submitting} block>
            登录
          </Button>
          <Typography.Text type="secondary" style={{ display: 'block', marginTop: 16 }}>
            如需账号或权限，请联系管理员。
          </Typography.Text>
        </Form>
      </Card>
    </div>
  );
}
